import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { LicenseSelectingFunction } from './licenseSelectingFunction';
import { AgreeLicenseModalComponent } from './agree-license-modal/agree-license-modal';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenService } from '../shared/service/token.service';
import { AuthenticationService } from '../shared/service/authentication.service';

@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.scss']
})
export class LicenseComponent implements OnInit, AfterViewInit {

  @ViewChild(AgreeLicenseModalComponent) agreeLicenseModalComponent: AgreeLicenseModalComponent;
  public content: string;
  public isRequestProccessing: boolean;
  public sub: any;
  public showAgreeLicenseDialog: boolean;

  constructor(
    private tokenService: TokenService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute) {
    this.content = '';
  }

  public getStartingLanguage() {
    return (this.tokenService.getCulture() != null) ? this.tokenService.getCulture() : navigator.language;
  }

  ngOnInit() {
    this.content = LicenseSelectingFunction(this.getStartingLanguage());
    this.sub = this.route.queryParams.subscribe(params => {
      this.showAgreeLicenseDialog = params['agreeLicenseAction'];
    });
  }

  ngAfterViewInit() {
    if (this.showAgreeLicenseDialog) {
      this.agreeLicenseModalComponent.show();
    }
  }

  public confirmLicense() {
    this.isRequestProccessing = true;
    this.authenticationService.doLoginAndAgreeLicense().subscribe(
      () => {
        this.router.navigate(['/']);
      },
      () => {},
      () => {
        this.isRequestProccessing = false;
      });
  }
}
